import SideBar from '../../../../components/common/SideBar/SideBarNew';
import Header from '../../../../components/common/Header/Header';
import Breadcrumb from '../../../../components/common/Breadcrumb';
import {
    SETTINGS_BREADCRUMB_PAGES,
    SP_SETTING_BREADCRUMB,
} from '../../../../Constants/BreadcrumbConstant';
import CircularLoader from 'components/common/CircularLoader/CircularLoader';
import React, { useContext, useEffect, useState } from 'react';
import { LoginContext } from '../../../../helpers/LoginContext';
import { apiDeleteRequest, apiGetRequest, apiPostRequest } from '../../../../helpers/Requests';
import { toast } from 'react-toastify';
import { Controller, useForm } from 'react-hook-form';
import SwitchWithIcon from '../../../../components/common/SwitchWithIcon';
import CustomButton from 'components/common/Button/CustomButton';
import { URL_SP_ROSTERING_SETTING_UPDATE, URL_SP_ROSTERING_SETTING } from 'store/services/URL';

const FundingSettings = () => {
    const { sideBarPadding, setRefreshNavigations } = useContext(LoginContext);
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const {
        register,
        handleSubmit,
        watch,
        setValue,
        formState: { isDirty },
        control,
        reset,
    } = useForm();

    const watchFormData = watch();
    const linkRosteringEnabled = watch('link_rostering_core_funding');

    useEffect(() => {
        const fetchSettings = async () => {
            setIsLoading(true);
            try {
                const response = await apiGetRequest(URL_SP_ROSTERING_SETTING);
                if (response?.status) {
                    const data = response.data?.general_settings || {};
                    const formData = {
                        link_rostering_core_funding: data?.link_rostering_core_funding || false,
                        funds_for_specific_line_item: data?.link_rostering_core_funding
                            ? data?.funds_for_specific_line_item || false
                            : false,
                        service_category_budget_not_available: data?.link_rostering_core_funding
                            ? data?.service_category_budget_not_available || false
                            : false,
                        allow_non_billable_shift: data?.link_rostering_core_funding
                            ? data?.allow_non_billable_shift || false
                            : false,
                    };
                    reset(formData);
                }
            } catch (error) {
                toast.error('Failed to load funding settings');
            } finally {
                setIsLoading(false);
            }
        };
        fetchSettings();
    }, [setValue, reset]);

    const onSubmit = async (data) => {
        setIsSaving(true);
        try {
            const payload = {
                link_rostering_core_funding: data?.link_rostering_core_funding || false,
                funds_for_specific_line_item: data?.link_rostering_core_funding
                    ? data?.funds_for_specific_line_item || false
                    : false,
                service_category_budget_not_available: data?.link_rostering_core_funding
                    ? data?.service_category_budget_not_available || false
                    : false,
                allow_non_billable_shift: data?.link_rostering_core_funding
                    ? data?.allow_non_billable_shift || false
                    : false,
            };

            const response = await apiPostRequest(URL_SP_ROSTERING_SETTING_UPDATE, payload);
            if (response.status) {
                toast.success('Funding settings updated successfully');

                reset(payload);
            } else {
                toast.error('Failed to update funding settings');
            }
        } catch (error) {
            toast.error('Failed to save funding settings');
        } finally {
            setIsSaving(false);
        }
    };
    return (
        <div>
            <div className="min-h-screen bg-gray-100">
                <SideBar />
                <div
                    className={`${
                        sideBarPadding ? 'lg:pl-[4rem] duration-300' : 'lg:pl-64 duration-300'
                    }  flex flex-col`}
                >
                    <Header
                        title="Funding Settings"
                        breadcrumb={
                            <Breadcrumb
                                pages={SP_SETTING_BREADCRUMB(
                                    SETTINGS_BREADCRUMB_PAGES.FUNDING_SETTINGS
                                )}
                            />
                        }
                    />
                    <section className="w-full sm:px-6 lg:px-8 mt-3">
                        <div className="mt-5 md:mt-0 md:col-span-2">
                            <div className="w-full ">
                                <div className="shadow sm:rounded-md sm:overflow-hidden p-4 bg-white shadow-md">
                                    {isLoading ? (
                                        <div className="flex justify-center py-8">
                                            <CircularLoader />
                                        </div>
                                    ) : (
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <div className="p-4">
                                                <h5 className="text-lg font-bold mb-4">
                                                    Funding Settings
                                                </h5>
                                                <div className="grid grid-cols-1 gap-y-6">
                                                    <div className="space-y-1">
                                                        <div className="flex items-start justify-between gap-4">
                                                            <label className="text-gray-800 text-sm font-medium">
                                                                Do you want to link rostering with
                                                                Core funding?
                                                            </label>
                                                            <Controller
                                                                name="link_rostering_core_funding"
                                                                control={control}
                                                                defaultValue={
                                                                    watchFormData?.link_rostering_core_funding ||
                                                                    false
                                                                }

                                                                render={({ field }) => (
                                                                    <SwitchWithIcon
                                                                        onChange={(value) => {
                                                                            field.onChange(value);
                                                                            setValue(
                                                                                'link_rostering_core_funding',
                                                                                value
                                                                            );
                                                                        }}
                                                                        checked={field.value}
                                                                    />
                                                                )}
                                                            />
                                                        </div>
                                                        <p className="text-xs text-gray-500">
                                                            Note: You will not be able to allocate
                                                            code if the funding is not available.
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="mt-6 flex justify-end">
                                                    <CustomButton
                                                        showLoading={isSaving}
                                                        isDisabled={
                                                            isSaving || !isDirty
                                                        }
                                                        variant="primary"
                                                        clickHandler={() => {
                                                            const buttonRef =
                                                                document.getElementById(
                                                                    'fundingSettingsBtnUpdate'
                                                                );
                                                            if (buttonRef) {
                                                                buttonRef.click();
                                                            }
                                                        }}
                                                        label="Update Changes"
                                                    />
                                                </div>
                                            </div>
                                            <button
                                                id="fundingSettingsBtnUpdate"
                                                type="submit"
                                                className="hidden sr-only"
                                            />
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default FundingSettings;
